import { Flex } from "@chakra-ui/react";
import { useNewHireJourneyDetailQuery } from "features/NewHireJourney/hooks";
import { CollapsibleHistory } from "features/PlatformEvents";
import MessageForm from "features/Resources/Message/Layout/MessageForm";
import SentMessage from "features/Resources/Message/Layout/SentMessage";
import { Message } from "features/Resources/Message/models";

interface MessageDrawerFormProps {
  message: Message;
}

export default function MessageDrawerForm({ message }: MessageDrawerFormProps) {
  const { data: newHireJourney } = useNewHireJourneyDetailQuery(message?.newHireJourneyId);
  if (!message) {
    return null;
  }

  return (
    <Flex direction="column">
      {message && (
        ["delivered", "skipped"].includes(message.status) ? (
          <SentMessage message={message} includeHeader={false} includeStatus={false} includeJourney={false} />
        ) : (
          <MessageForm
            data={message}
            includeHeader={false}
            includeMenu={false}
            includeStatus={false}
            includeJourney={false}
            isPending={newHireJourney?.isPending ?? false}
          />
        )
      )}
      <CollapsibleHistory entityId={message.id} entityType="Message" eventType="message" />
    </Flex>
  );
}
